import React, {useState, useEffect, useCallback} from "react";
import { Link } from "react-router-dom";
import { StyleSheet, css } from "aphrodite";
import MiniNavBar from "./mini_nav_bar";


function NavBar({showRouteBar = false, isStatic=false, display=true}){

    //#region code

    const [widowWidth, setWindowWidth] = useState(window.innerWidth)
    useEffect(()=>{
        window.addEventListener("resize", getWindowWidth);
        return () => window.removeEventListener("resize", getWindowWidth);
    },[])

    const getWindowWidth = () =>{
         setWindowWidth(window.innerWidth)
    }
    //variables

    const [isSticky, setIsSticky] = useState(false);

    //functions
    //useEffects
    useEffect(() => {
        window.onscroll = () => {
            setIsSticky(window.scrollY > (16 * 5))
        }
    }, [])

    const [miniMenu, setMiniMenu] = useState(false)

    const onClickHandler = () =>{
        setMiniMenu(prev => !prev)
    }
    // useEffect(() => {
    //     callbackSticky(isSticky)
    // },[isSticky])
    /* #endregion */

    //#region style
    const styles = StyleSheet.create({
        navContainer: {
            width: isStatic ? 'auto' : '100vw',
            position:isStatic ? 'relative' : 'fixed',
            top:0,
            zIndex: 400,
        },
        topBarContainer: {
            width:'100%',
            overflow:'hidden',
            transition:'all 0.4s',
            display:'none',
            /*tablet and bigger screens*/
            //isStatic ?
            "@media (min-width: 1024px)": {
                height: isStatic  ? 'fit-content' : (!isSticky ? 'fit-content' : '0px'),
                display:'block',
                transition: '1s all',

            }
        },
        navBarContainer: {
            position:'relative',
            transition:'all 0.3s',
            backgroundColor:  isSticky ? "#F0EFEC" : "#F0EFEC",
            border:"none",
            top:0,
            zIndex: 120,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            height:'5rem',
            WebkitUserSelect: 'none',
            MsUserSelect: 'none',
            UserSelect: 'none',
            padding:'0rem',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                flexWrap: "wrap",
                justifyContent: "space-between",
                padding:'0rem',
            }
        },
        marginContainer: {
            display:'flex',
            justifyContent: 'center',
            alignItems:'center',
            marginLeft:'auto',
            marginRight: 'auto',
            maxWidth: '1280px',
            width:'100%',
            "@media (min-width: 1024px)": {
                justifyContent:'center',
            }
        },
        logoContainer: {
            display: "inline-block",
        },
        imageLogo: {
            width: "70px",
            flexShrink: "3",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                marginLeft:'2rem',
            }
        },
        linksContainer: {
            display: "none",
            justifyContent: "space-evenly",
            textAlign: "right",
            flexShrink: "3",
            width:"100%",
            height:'100%',
            flexWrap: "wrap",
            fontWeight: 600,
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display:'flex'
            }
        },
        linkItem: {
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            fontStyle: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            width:'8rem',
            height:'auto',
            color: '#011a39',
            cursor:'pointer',
            padding: "4px 20px 4px 20px",
            borderRadius: "10px",
            transition: '.3s all',
            position:'relative',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                ':hover':{
                    backgroundColor:'rgb(190,190,190,0.2)'
                }
            }
        },
        activeLinkItem: {
            fontFamily: "Oswald",
            fontSize:'1.5rem',
            fontStyle: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            width:'8rem',
            height:'auto',
            color : "#fec803",
            cursor:'pointer',
            padding: "4px 20px 4px 20px",
            borderRadius: "10px",
            transition: '.3s all',
            position:'relative',
            textAlign: "center",
            alignSelf: "center",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                ':hover':{
                    backgroundColor:'rgb(190,190,190,0.2)'
                }
            }
        },
        searchBoxContainer: {
            display:'none',
            alignItems:'center',
            justifyContent:'end',
            width:'14rem',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display:'flex'
            }
        },
        searchBox: {
            height: '2rem',
            minWidth: '2rem',
            display:'flex',
            flexDirection:'row',
            justifyContent:'end',
            alignItems:'center',
            borderRadius: '10px',
            overflow:'hidden',
            transition:'all 0.3s',
            width: '100%',
        },
        routeBarContainer: {
            width:'100%',
            height: showRouteBar ? 'fit-content' : '0px',
            overflow:'hidden',
            transition:'all 0.4s',
        },
        /* Mobile */
        mobileContainer: {
            display:'flex',
            justifyContent:'end',
            alignItems:'center',
            gap:'1rem',
            width:'100%',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                display:'none'
            }
        },
        menuIcon: {
            width:'2.5rem',
            aspectRatio:'1',
            flex:'none',
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            fontSize:'2rem',
            color:'white',
            transition:'all 0.3s'
        },
        menuIconRotate: {
            transform:`rotate(90deg)`,
        },
    });
    //#endregion

    //#region view
    return(
        <>
        {
            display ?

        
        <div className={css(styles.navContainer)}>
            <nav className={css(styles.navBarContainer)} >
                <div className={css(styles.marginContainer)}>
                    {
                        widowWidth >= 1024 ?
                        <>
                            <Link className={css(styles.logoContainer)} to="/"><img className={css(styles.imageLogo)} src={"/resources/logo.png"} alt="jf welding img"/></Link>
                            <div className={css(styles.linksContainer)}>
                                <Link className={css(styles.linkItem)}
                                    to="/products"
                                    >PRODUCTS
                                </Link>

                                <Link className={css(styles.linkItem)}
                                    to="/about-us"
                                    >ABOUT US
                                </Link>

                                <Link className={css(styles.linkItem)}
                                    to="/support"
                                    >SUPPORT
                                </Link>
                            </div>
                        </>
                        :
                        <>
                            <div className={css(styles.logoContainer)} onClick={()=>onClickHandler()}>
                                <img className={css(styles.imageLogo)} src={"/resources/logo.png"} alt="jf welding img"/>
                            </div>
                            {
                                miniMenu?
                                <MiniNavBar click={setMiniMenu}/>:<></>
                            }
                            
                        </>
                    }
                </div>
            </nav>
        </div>:<></>
        }</>
    )
    //#endregion
}
export default NavBar